
import './App.scss';
import Home from './Pages/Home';
import Service from "./Pages/Service";
import About from "./Pages/About";
import OurProjects from "./Pages/OurProjects";
import ContactUs from "./Pages/ContactUs";

import { Routes, Route } from "react-router-dom";


function App() {
  
  return (
    
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route exact path="/service" element={<Service/>} />
        <Route exact path="/about" element={<About/>} />
        <Route exact path="/ourProjects" element={<OurProjects/>} />
        <Route exact path="/contactUs" element={<ContactUs/>} />
      </Routes>
     
  );
};

export default App;
